<template>
    <aside-block v-if="question">
        <template slot="header">Задание №{{progress.current}} из {{progress.length}}</template>

        <template slot="default">
            <div class="aside-title">{{question.title}}</div>
            <div class="aside-description" v-if="question.description">{{question.description}}</div>
            <div class="aside-task" v-if="question.task">
                <span class="aside-task__title">Задача:</span>
                {{question.task}}
            </div>
        </template>

        <template slot="footer">
            <v-btn color="success" :loading="pending" @click="dialog = true">Следующее задание<v-icon>chevron_right</v-icon></v-btn>
        </template>

        <v-dialog v-model="dialog" max-width="490">
            <v-card>
                <v-card-text>Вы уверены что хотите перейти к следующему заданию?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darken-1" flat @click="dialog = false">Нет</v-btn>
                    <v-btn color="green darken-1" style="color: #fff" @click="onContinue">Да</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </aside-block>
</template>

<script>
    import AsideBlock from '@/views/session/aside.vue'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                dialog: false,
                pending: false
            }
        },
        components: {
            AsideBlock
        },
        computed: {
            ...mapGetters('questions', ['question', 'progress'])
        },
        methods: {
            onContinue () {
                if (this.pending) return
                this.dialog = false
                this.pending = true

                this.$store.dispatch('questions/sendAnswer')
                    .then(() => this.pending = false)
                    .catch(() => this.pending = false)
            },
        }
    }
</script>
<style lang="stylus" scoped>
    .aside-title {
        font-size 1.8rem
        line-height 1.2
        color rgba(255, 55, 5, .8)
        margin-bottom 15px
    }
    .aside-task {
        padding-top 10px

        &__title {
            font-weight bold
            display block
            color #8a8a8a
        }
    }
</style>
